import React, { useEffect, useMemo, useState } from "react";
import Bookingdetails1 from "./Bookingsdetails1";
import formatDate from "../../common/Formatdate";
import formatDateAndTime from "../../common/formatDateAndTime";
import toast from "react-hot-toast";
import formatTime from "../../common/formatTime";
import InfoIcon from "@mui/icons-material/Info";
import { TextField } from "@mui/material";
import { BlinkBlur } from "react-loading-indicators";
import UseOnlineStatus from "../../common/UseOnlineStatus";
import moment from "moment";

const SUBSCRIPTION_PACKAGE_DAYS = {
  dailyRateWeekly: 7,
  dailyRateFortnightly: 15,
  dailyRateMonthly: 30,
};

const Reschedule = ({
  summaryDetails,
  vehicleDetails,
  paymentDetailsData,
  getBookingDetail,
  selectedRow,
  cities,
  bookingRescheduleDetails,
  fleetDeliveryAgentList,
  fleetDeliveryAgentBooking,
}) => {
  const { isOnline, isSlowConnection } = UseOnlineStatus();
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  const profile = JSON.parse(localStorage.getItem("profile"));
  const paymentCollectionType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.paymentCollectionType;
  delete paymentCollectionType?.inverted;
  const [inputData, setInputData] = useState({
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
  });
  const [affectedBookings, setAffectedBookings] = useState([]);
  const [costcalulator, setcostcalulator] = useState(null);
  const [generatePaymentlinks, setGeneratePaymentlinks] = useState(null);
  const [transactiondetails, settransactiodetails] = useState({
    transactionid: "",
    transactioncharges: "",
    paymentmode: "",
    payableamount: "",
    paymentremarks: "",
    attachments: null,
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [paymentSavedDetails, setPaymentSavedDetails] = useState(null);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [errors, setErrors] = useState({});
  const [paymentTypeErrors, setPaymentTypeErrors] = useState("");
  const [dateTimeError, setDateTimeError] = useState("");
  const [loading, setLoading] = useState(false);
  const [minBookingHrs, setMinBookingHrs] = useState(null);
  const [showAffectedBookings, setShowAffectedBookings] = useState(false);
  const [paymentLinkGenerated, setPaymentLinkGenerated] = useState(false);

  const hasUnstableConnection = !isOnline || isSlowConnection;

  const showNetworkAlert = () => {
    setPaymentLinkGenerated(false);
    toast.error(
      "Please check your network connection. Your internet connection appears to be unstable.",
      {
        position: "bottom-center",
        style: {
          background: "white",
          color: "red",
          fontWeight: "medium",
          marginBottom: "20px",
        },
      },
    );
  };

  console.log("paymentLinkGenerated", paymentLinkGenerated);

  const fetchConfig = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/bookingconfigs?cityId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );

      const data = await response.json();
      if (data?.statusCode === "0100") {
        setMinBookingHrs(data?.entities?.rows[0]?.minBookingHrs || 0);
      }
    } catch (err) {
      console.error("Error fetching booking config:", err);
    }
  };

  useEffect(() => {
    if (summaryDetails?.cityId) {
      fetchConfig(summaryDetails?.cityId);
    }
  }, [summaryDetails]);

  const generatepaymentlink = async (type) => {
    if (hasUnstableConnection) {
      showNetworkAlert();
      return;
    }

    setPaymentLinkGenerated(true);
    let payload;

    if (type === "generate") {
      payload = {
        bookingId: summaryDetails?.bookingId,
        amount: Math.round(pendingAmount?.pendingAmount * 100),
        customerName: summaryDetails?.customerName,
        contactEmail: summaryDetails?.customerEmail,
        customerContact: summaryDetails?.customerMobile,
        customerId: summaryDetails?.customerId,
      };
    } else {
      payload = {
        paymentId: generatePaymentlinks?.paymentId,
        id: generatePaymentlinks?.id,
        bookingId: summaryDetails?.id,
        inquiryCode: summaryDetails?.inquiryCode,
      };
    }
    try {
      const response = await fetch(`${apiUrl}/api/paymentlinks`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setPaymentLinkGenerated(false);
        if (data?.dataValues?.status === "created") {
          toast.success("Payment link generated successfully.");
        } else {
          toast.success("Payment Captured successfully.");
          // getBookingDetail(selectedRow?.inquiryID, "inquiry");
        }
        setGeneratePaymentlinks(data?.dataValues);
      } else {
        setPaymentLinkGenerated(false);
        toast.error(data?.message);
      }
      return data;
    } catch (error) {
      return;
      setPaymentLinkGenerated(false);
      console.error("Error fetching Affected Bookings:", error);
    }
  };

  const [pendingAmount, setPendingAmount] = useState(null);

  const getCalculatependingamount = async (resData) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/seldrivebookingreschedulings/calculatependingamount`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            rescheduleRentalDetails: resData,
            bookingInfo: {
              costToCustomer: summaryDetails?.costToCustomer,
              weekdayRent: summaryDetails?.weekdayRent,
              weekendRent: summaryDetails?.weekendRent,
              bookingHrs: summaryDetails?.bookingHrs,
              deliveryCharges: summaryDetails?.deliveryCharges,
              pickupCharges: summaryDetails?.pickupCharges,
              taxAmount: summaryDetails?.taxAmount,
              discountAmount: summaryDetails?.discountAmount,
              discountPercentage: Number(summaryDetails?.discountPercentage),
              securityDeposit: summaryDetails?.securityDeposit,
            },
            totalAmountPaid: paymentDetailsData?.totalAmountPaid,
          }),
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setShowAffectedBookings(true);
        setPendingAmount(data?.entities);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching rescheduleCalculator:", error);
    }
  };

  const rescheduleCostCalculator = async () => {
    try {
      let query = "";

      if (inputData?.startDate && inputData?.startTime) {
        query += `startDate=${inputData.startDate}T${inputData.startTime}`;
      }

      if (inputData?.endDate && inputData?.endTime) {
        query += `&endDate=${inputData.endDate}T${inputData.endTime}`;
      }

      if (summaryDetails?.packageDetails) {
        query += `&groupId=61`;
        query += `&packageId=${summaryDetails.packageDetails}`;
      }

      if (
        summaryDetails?.packageSelectedKey === "dailyRateWeekly" ||
        summaryDetails?.packageSelectedKey === "dailyRateFortnightly" ||
        summaryDetails?.packageSelectedKey === "dailyRateMonthly"
      ) {
        query += `&bookingId=${summaryDetails?.id}`;
      }

      query += `&isPeakSeasons=false`;
      query += `&discountPercentage=0`;

      // Dynamic API endpoint
      const apiEndpoint =
        summaryDetails?.packageSelectedKey === "dailyRateWeekly" ||
        summaryDetails?.packageSelectedKey === "dailyRateFortnightly" ||
        summaryDetails?.packageSelectedKey === "dailyRateMonthly"
          ? `${apiUrl}/api/subscriptionbookings/rent-calculator`
          : `${apiUrl}/api/booking/costcalulator`;

      const response = await fetch(`${apiEndpoint}?${query}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        await getCalculatependingamount(data?.dataValues);
        setcostcalulator(data?.dataValues);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching rescheduleCalculator:", error);
    }
  };

  const getaffectedbookings = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${apiUrl}/api/bookings/getbookingbydates?startDate=${
          inputData?.startDate + "T" + inputData?.startTime
        }&endDate=${inputData?.endDate + "T" + inputData?.endTime}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        const filtered = data?.dataValues?.filter(
          (item) => String(item.vehicleId) === String(vehicleDetails?.id),
        );
        setAffectedBookings(filtered);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Affected Bookings:", error);
    }
  };

  const today = new Date();
  const todayDateStr = today.toISOString().split("T")[0]; // yyyy-mm-dd
  const currentTimeStr = today.toTimeString().slice(0, 5); // HH:mm

  const getMinTime = (date) => {
    return date === todayDateStr ? currentTimeStr : undefined;
  };

  const bookedDate = summaryDetails?.bookFrom
    ? new Date(summaryDetails.bookFrom)
    : null;

  const minEndDate = inputData.startDate
    ? inputData.startDate // ❗ allow SAME DAY
    : bookedDate
      ? bookedDate.toISOString().split("T")[0]
      : todayDateStr;

  // Allow same-day end date
  const dynamicMinEndDate = inputData.startDate
    ? inputData.startDate
    : minEndDate;

  // Calculate min end time based on min booking hrs
  const getMinEndTime = () => {
    if (!inputData.startDate || !inputData.startTime) return "";

    if (inputData.startDate === inputData.endDate) {
      const start = new Date(`${inputData.startDate}T${inputData.startTime}`);
      const minEnd = new Date(
        start.getTime() + (minBookingHrs || 0) * 60 * 60 * 1000,
      );
      return minEnd.toTimeString().slice(0, 5);
    }

    return "";
  };

  const minStartDate = bookedDate
    ? new Date(bookedDate.setDate(bookedDate.getDate() + 1))
        .toISOString()
        .split("T")[0]
    : todayDateStr;

  // const rescheduleDetailsInput = [
  //   {
  //     label: "Start Date",
  //     type: "date",
  //     isEnable: false,
  //     value: "startDate",
  //     min: bookedDate ? bookedDate.toISOString().split("T")[0] : todayDateStr, // ✅ restrict to booked start date
  //     currentvalue: `Current Start Date ${formatDate(
  //       summaryDetails?.bookFrom
  //     )}`,
  //   },
  //   {
  //     label: "Start Time",
  //     type: "time",
  //     isEnable: false,
  //     value: "startTime",
  //     min: bookedDate ? bookedDate.toTimeString().slice(0, 5) : currentTimeStr, // ✅ restrict to booked start time
  //     currentvalue: `Current Start Time ${formatTime(
  //       summaryDetails?.bookFrom
  //     )}`,
  //   },
  //   {
  //     label: "End Date",
  //     type: "date",
  //     isEnable: false,
  //     value: "endDate",
  //     min: bookedDate ? bookedDate.toISOString().split("T")[0] : todayDateStr, // ✅ restrict to booked end date
  //     currentvalue: `Current End Date ${formatDate(summaryDetails?.bookTo)}`,
  //   },
  //   {
  //     label: "End Time",
  //     type: "time",
  //     isEnable: false,
  //     value: "endTime",
  //     min: bookedDate ? bookedDate.toTimeString().slice(0, 5) : undefined, // ✅ restrict to booked end time
  //     currentvalue: `Current End Time ${formatTime(summaryDetails?.bookTo)}`,
  //   },
  // ];

  const rescheduleDetailsInput = [
    {
      label: "Start Date",
      type: "date",
      isEnable: false,
      value: "startDate",
      min: minStartDate,
      currentvalue: `Current Start Date ${formatDate(
        summaryDetails?.bookFrom,
      )}`,
    },
    {
      label: "Start Time",
      type: "time",
      isEnable: false,
      value: "startTime",
      min: bookedDate ? bookedDate.toTimeString().slice(0, 5) : currentTimeStr,
      currentvalue: `Current Start Time ${formatTime(
        summaryDetails?.bookFrom,
      )}`,
    },
    {
      label: "End Date",
      type: "date",
      isEnable: false,
      value: "endDate",
      min: minEndDate, // ✅ next day after Start Date
      currentvalue: `Current End Date ${formatDate(summaryDetails?.bookTo)}`,
    },
    {
      label: "End Time",
      type: "time",
      isEnable: false,
      value: "endTime",
      min: bookedDate ? bookedDate.toTimeString().slice(0, 5) : undefined,
      currentvalue: `Current End Time ${formatTime(summaryDetails?.bookTo)}`,
    },
  ];

  const transactionDetailsInput = [
    {
      label: "Transaction Id",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "transactionid",
    },
    {
      label: "Transaction Charges",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "transactioncharges",
    },
    {
      label: "Payment Mode",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "paymentmode",
    },
    {
      label: "Payable Amount",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "payableamount",
    },
    {
      label: "Payment Remarks",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "paymentremarks",
    },
    {
      label: "Attachments",
      type: "file",
      isEnable: false,
      placeholder: "",
      value: "attachments",
    },
  ];

  const handleInputChange = async (key, event) => {
    let value;

    if (event?.target?.type === "file") {
      value = event.target.files[0];

      if (value) {
        const formData = new FormData();
        formData.append("entityName", "booking");
        formData.append("fileTags", "vehicle");
        formData.append("files", value);

        try {
          const response = await fetch(`${apiUrl}/fileapi/upload`, {
            method: "POST",
            body: formData,
          });
          const data = await response.json();
          if (data) {
            toast.success("Image Uploaded successfully.", {
              position: "bottom-center",
              style: {
                background: "blue", // override background
                color: "white",
                fontWeight: "medium",
                marginBottom: "20px",
              },
            });
            setSelectedFile(data?.uploaded);
            settransactiodetails((prev) => ({
              ...prev,
              attachments: data?.uploaded,
            }));
            validateField("attachments", data?.uploaded);
          }
        } catch (error) {
          console.error("Error uploading file:", error);
        }
      }
    } else {
      value = event?.target?.value !== undefined ? event.target.value : event;

      settransactiodetails((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
    validateField(key, value);
  };

  const validateField = (key, value) => {
    let errorMsg = "";

    if (key === "transactioncharges" && !/^\d+$/.test(value)) {
      errorMsg = "* Accepts only numbers";
    }
    if (key === "payableamount" && !/^\d+(\.\d{1,2})?$/.test(value)) {
      errorMsg = "* Accepts only numbers (up to 2 decimals)";
    }
    if (key === "documentype" && !value) {
      errorMsg = "Please select a document type";
    }
    if (key === "paymentmode" && !/^[a-zA-Z ]*$/.test(value)) {
      errorMsg = "* Accepts only alphabets";
    }
    if (key === "attachments" && !value) {
      errorMsg = "* Attachment required";
    }

    setErrors((prev) => ({ ...prev, [key]: errorMsg }));
    return errorMsg === "";
  };

  const handleSave = async () => {
    if (hasUnstableConnection) {
      showNetworkAlert();
      return;
    }

    let isValid = true;
    const newErrors = {};

    // Required fields
    const requiredFields = [
      "transactionid",
      "transactioncharges",
      "paymentmode",
      "payableamount",
      "paymentremarks",
      "attachments",
    ];

    requiredFields.forEach((field) => {
      if (!transactiondetails[field]) {
        newErrors[field] = "* Required";
        isValid = false;
      } else {
        const valid = validateField(field, transactiondetails[field]);
        if (!valid) isValid = false;
      }
    });

    setErrors(newErrors);

    if (!isValid) {
      toast.error("Please fix errors before submitting payment details");
      return;
    }

    toast.loading("Processing... Please wait", {
      id: "transaction", // same ID to update later
      position: "bottom-center",
    });

    try {
      const response = await fetch(`${apiUrl}/api/bookingtransactions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          amount: transactiondetails?.payableamount,
          paymentMode: transactiondetails?.paymentmode,
          transactionCode: transactiondetails?.transactionid,
          transactionalCharges: transactiondetails?.transactioncharges,
          bookingId: summaryDetails?.id,
          description: transactiondetails?.paymentremarks,
          attachments: transactiondetails?.attachments
            ? JSON.stringify(transactiondetails.attachments)
            : null,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.dismiss("transaction");
        toast.success(
          "Payment details added successfully. Click update booking to confirm the process.",
          {
            position: "bottom-center",
            style: {
              background: "blue",
              color: "white",
              fontWeight: "medium",
              marginBottom: "20px",
            },
          },
        );
        settransactiodetails({
          transactionid: "",
          transactioncharges: "",
          paymentmode: "",
          payableamount: "",
          paymentremarks: "",
        });
        setPaymentSavedDetails(data?.dataValues);
      }
      return data;
    } catch (error) {
      return console.error(
        "Error fetching POST booking transaction initiate booking:",
        error,
      );
    }
  };

  const updateBooking = async () => {
    // if (!paymentDetailsData?.fleetDeliveryAgentBookings?.id) {
    //   return toast.error("Assign delivery agent to reschedule the booking", {
    //     position: "bottom-center",
    //     style: {
    //       background: "white", // override background
    //       color: "red",
    //       fontWeight: "medium",
    //     },
    //   });
    // }

    toast.loading("Processing... Please wait", {
      id: "reschedule", // same ID to update later
      position: "bottom-center",
    });

    let payload;
    if (selectedPaymentType === "Post Paid") {
      payload = {
        modifiedBy: profile?.id,
        bookingId: paymentDetailsData?.id,
        bookingCode: paymentDetailsData?.bookingCode,
        oldWdayRent: paymentDetailsData?.weekdayRent,
        oldWendRent: paymentDetailsData?.weekendRent,
        oldDiscountPercentage: paymentDetailsData?.discountPercentage,
        oldDiscountAmount: paymentDetailsData?.discountAmount,
        oldTaxAmount: paymentDetailsData?.taxAmount,
        newRent: pendingAmount?.rescheduleRentalDetails?.costToCustomer,
        oldRent: paymentDetailsData?.costToCustomer,
        currentStartDate: paymentDetailsData?.bookFrom,
        newStartDate: inputData?.startDate + "T" + inputData?.startTime,
        currentEndDate: paymentDetailsData?.bookTo,
        newEndDate: inputData?.endDate + "T" + inputData?.endTime,
        paymentType: selectedPaymentType,
        bookingObject: {
          bookFrom: inputData?.startDate + "T" + inputData?.startTime,
          bookTo: inputData?.endDate + "T" + inputData?.endTime,
          bookingStatus: fleetBookingStatus?.inverted?.bookingRescheduled,
          weekdayHrs: pendingAmount?.rescheduleRentalDetails?.weekdayHrs,
          weekendHrs: pendingAmount?.rescheduleRentalDetails?.weekendHrs,
          overallFreeKm: pendingAmount?.rescheduleRentalDetails?.totalFreeKms,
          id: paymentDetailsData?.id,
          taxAmount: pendingAmount?.rescheduleRentalDetails?.taxAmount,
          weekdayRent: pendingAmount?.rescheduleRentalDetails?.weekdayRent,
          weekendRent: pendingAmount?.rescheduleRentalDetails?.weekendRent,
          costToCustomer:
            pendingAmount?.rescheduleRentalDetails?.costToCustomer,
          discountAmount: 0,
          discountPercentage: 0,
          bookingHrs: pendingAmount?.rescheduleRentalDetails?.totalHrs,
        },
        bookingHistory: {
          agentId: profile?.id,
          agentName: profile?.name,
          emailId: profile?.email,
          action: "Trip Rescheduled",
          bookingId: paymentDetailsData?.id,
        },
        tempBookingObject: {
          bookFrom: inputData?.startDate + "T" + inputData?.startTime,
          bookTo: inputData?.endDate + "T" + inputData?.endTime,
        },
      };
    } else if (selectedPaymentType === "Pre Paid") {
      payload = {
        modifiedBy: profile?.id,
        bookingId: paymentDetailsData?.id,
        bookingCode: paymentDetailsData?.bookingCode,
        oldWdayRent: paymentDetailsData?.weekdayRent,
        oldWendRent: paymentDetailsData?.weekendRent,
        oldDiscountPercentage: paymentDetailsData?.discountPercentage,
        oldDiscountAmount: paymentDetailsData?.discountAmount,
        oldTaxAmount: paymentDetailsData?.taxAmount,
        newRent: pendingAmount?.rescheduleRentalDetails?.costToCustomer,
        oldRent: paymentDetailsData?.costToCustomer,
        currentStartDate: paymentDetailsData?.bookFrom,
        newStartDate: inputData?.startDate + "T" + inputData?.startTime,
        currentEndDate: paymentDetailsData?.bookTo,
        newEndDate: inputData?.endDate + "T" + inputData?.endTime,
        paymentType: selectedPaymentType,
        bookingObject: {
          bookFrom: inputData?.startDate + "T" + inputData?.startTime,
          bookTo: inputData?.endDate + "T" + inputData?.endTime,
          bookingStatus: fleetBookingStatus?.inverted?.bookingRescheduled,
          weekdayHrs: pendingAmount?.rescheduleRentalDetails?.weekdayHrs,
          weekendHrs: pendingAmount?.rescheduleRentalDetails?.weekendHrs,
          overallFreeKm: pendingAmount?.rescheduleRentalDetails?.totalFreeKms,
          id: paymentDetailsData?.id,
          taxAmount: pendingAmount?.rescheduleRentalDetails?.taxAmount,
          weekdayRent: pendingAmount?.rescheduleRentalDetails?.weekdayRent,
          weekendRent: pendingAmount?.rescheduleRentalDetails?.weekendRent,
          costToCustomer:
            pendingAmount?.rescheduleRentalDetails?.costToCustomer,
          discountAmount: 0,
          discountPercentage: 0,
          bookingHrs: pendingAmount?.rescheduleRentalDetails?.totalHrs,
        },
        bookingHistory: {
          agentId: profile?.id,
          agentName: profile?.name,
          emailId: profile?.email,
          action: "Trip Rescheduled",
          bookingId: paymentDetailsData?.id,
        },
        tempBookingObject: {
          bookFrom: inputData?.startDate + "T" + inputData?.startTime,
          bookTo: inputData?.endDate + "T" + inputData?.endTime,
        },
      };
    } else if (selectedPaymentType === "Freeze") {
      payload = {
        modifiedBy: profile?.id,
        bookingId: paymentDetailsData?.id,
        bookingCode: paymentDetailsData?.bookingCode,
        oldWdayRent: paymentDetailsData?.weekdayRent,
        oldWendRent: paymentDetailsData?.weekendRent,
        oldDiscountPercentage: paymentDetailsData?.discountPercentage,
        oldDiscountAmount: paymentDetailsData?.discountAmount,
        oldTaxAmount: paymentDetailsData?.taxAmount,
        newRent: pendingAmount?.rescheduleRentalDetails?.costToCustomer,
        oldRent: paymentDetailsData?.costToCustomer,
        currentStartDate: paymentDetailsData?.bookFrom,
        newStartDate: inputData?.startDate + "T" + inputData?.startTime,
        currentEndDate: paymentDetailsData?.bookTo,
        newEndDate: inputData?.endDate + "T" + inputData?.endTime,
        paymentType: selectedPaymentType,
        bookingObject: {
          bookFrom: inputData?.startDate + "T" + inputData?.startTime,
          bookTo: inputData?.endDate + "T" + inputData?.endTime,
          bookingStatus: fleetBookingStatus?.inverted?.bookingRescheduled,
          weekdayHrs: pendingAmount?.rescheduleRentalDetails?.weekdayHrs,
          weekendHrs: pendingAmount?.rescheduleRentalDetails?.weekendHrs,
          overallFreeKm: pendingAmount?.rescheduleRentalDetails?.totalFreeKms,
          id: paymentDetailsData?.id,
          discountAmount: 0,
          discountPercentage: 0,
          taxAmount: pendingAmount?.rescheduleRentalDetails?.taxAmount,
          weekdayRent: pendingAmount?.rescheduleRentalDetails?.weekdayRent,
          weekendRent: pendingAmount?.rescheduleRentalDetails?.weekendRent,
          bookingHrs: pendingAmount?.rescheduleRentalDetails?.totalHrs,
          // costToCustomer: pendingAmount?.rescheduleRentalDetails?.costToCustomer,
        },
        bookingHistory: {
          agentId: profile?.id,
          agentName: profile?.name,
          emailId: profile?.email,
          action: "Trip Rescheduled",
          bookingId: paymentDetailsData?.id,
        },
        tempBookingObject: {
          bookFrom: inputData?.startDate + "T" + inputData?.startTime,
          bookTo: inputData?.endDate + "T" + inputData?.endTime,
        },
      };
    }

    // return

    try {
      const response = await fetch(
        `${apiUrl}/api/seldrivebookingreschedulings`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(payload),
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.dismiss("reschedule");
        toast.success("Booking Reschedule Confirmed.");
        await handleAssign("Delivery");
        getBookingDetail(selectedRow?.inquiryID, "inquiry");
        bookingRescheduleDetails(summaryDetails?.id);
      }
      return data;
    } catch (error) {
      return console.error(
        "Error fetching POST booking transaction initiate booking:",
        error,
      );
    }
  };

  // const handleAssign = async (type) => {
  //   let body;
  //   let endUrl;
  //   if (type === "Delivery") {
  //     endUrl = "fleetdeliveryagentbookings";
  //     if (fleetDeliveryAgentList.length > 0) {
  //       body = {
  //         id: fleetDeliveryAgentList[0]?.id,
  //         isUpdateAgent: true,
  //         deliveryDate: inputData?.endDate + "T" + inputData?.endTime,
  //       };
  //     }
  //   } else {
  //     endUrl = "fleetpickupagentbookings";
  //     body = {
  //       id: fleetDeliveryAgentList[0]?.id,
  //       isUpdateAgent: true,
  //       deliveryDate: "",
  //     };
  //   }

  //   try {
  //     const response = await fetch(`${apiUrl}/api/${endUrl}`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "application/json",
  //         Authorization: `${token}`,
  //       },
  //       body: JSON.stringify(body),
  //     });
  //     const data = await response.json();
  //     if (data?.statusCode === "0100") {
  //       if (type === "Delivery") {
  //         fleetDeliveryAgentBooking(data?.dataValues.bookingId);
  //       }
  //       // else {
  //       //   fleetPickupAgentBooking(data?.dataValues.bookingId);
  //       // }
  //     }
  //     return data;
  //   } catch (error) {
  //     return console.error("Error fetching Users List:", error);
  //   }
  // };

  const handleAssign = async (type) => {
    let body;
    let endUrl;

    try {
      if (type === "Delivery") {
        endUrl = "fleetdeliveryagentbookings";

        body = {
          id: fleetDeliveryAgentList[0]?.id,
          isUpdateAgent: true,
          deliveryDate: `${inputData?.endDate}T${inputData?.endTime}`,
        };
      } else {
        endUrl = "fleetpickupagentbookings";

        body = {
          id: fleetDeliveryAgentList[0]?.id,
          isUpdateAgent: true,
          deliveryDate: "",
        };
      }

      const response = await fetch(`${apiUrl}/api/${endUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (data?.statusCode === "0100") {
        toast.success(`${type} agent assigned successfully.`);
        if (type === "Delivery")
          fleetDeliveryAgentBooking(data?.dataValues?.bookingId);
      } else {
        toast.warn("Agents still not assigned.");
        // (data?.message || "Agents still not assigned.");
      }

      return data;
    } catch (error) {
      console.error("Error fetching Users List:", error);
      toast.error("Agent assignment failed, please retry.");
    }
  };

  useEffect(() => {
    if (pendingAmount?.pendingAmount > 0) {
      settransactiodetails((prev) => ({
        ...prev,
        payableamount: pendingAmount?.pendingAmount,
      }));
    } else if (pendingAmount?.pendingAmount < 0) {
      settransactiodetails((prev) => ({
        ...prev,
        payableamount: 0,
      }));
    }
  }, [pendingAmount]);

  const validateDateTime = () => {
    if (!inputData.startDate) return "Please select Start Date";
    if (!inputData.startTime) return "Please select Start Time";
    if (!inputData.endDate) return "Please select End Date";
    if (!inputData.endTime) return "Please select End Time";
    return "";
  };

  const subscriptionDays = useMemo(() => {
    if (!SUBSCRIPTION_PACKAGE_DAYS[summaryDetails?.packageSelectedKey]) {
      return null;
    }

    const originalStart = moment(summaryDetails?.bookFrom);
    const originalEnd = moment(summaryDetails?.bookTo);
    if (!originalStart.isValid() || !originalEnd.isValid()) return null;

    const durationInDays = originalEnd.diff(originalStart, "hours", true) / 24;
    return Number.isInteger(durationInDays) && durationInDays > 0
      ? durationInDays
      : null;
  }, [
    summaryDetails?.bookFrom,
    summaryDetails?.bookTo,
    summaryDetails?.packageSelectedKey,
  ]);

  useEffect(() => {
    const { startDate, startTime, endDate, endTime } = inputData;
    if (startDate && startTime && endDate && endTime) {
      const start = new Date(`${startDate}T${startTime}`);
      const end = new Date(`${endDate}T${endTime}`);
      const diffHrs = (end - start) / (1000 * 60 * 60);

      if (diffHrs < (minBookingHrs || 0)) {
        setShowAffectedBookings(false);
        setcostcalulator(null);
        setDateTimeError(`Minimum booking duration is ${minBookingHrs} hours`);
        return;
      }

      const durationInDays = diffHrs / 24;
      const isSubscription = Boolean(
        SUBSCRIPTION_PACKAGE_DAYS[summaryDetails?.packageSelectedKey],
      );
      let subscriptionDateTimeError = "";

      if (isSubscription) {
        if (!subscriptionDays) {
          subscriptionDateTimeError =
            "Unable to determine the original subscription duration. Please verify the booking dates.";
        } else if (!Number.isInteger(durationInDays)) {
          subscriptionDateTimeError =
            "Rescheduled duration should be in complete days. Hours and minutes are not allowed.";
        } else if (durationInDays !== subscriptionDays) {
          subscriptionDateTimeError = `This booking was created for ${subscriptionDays} days. During rescheduling, you must select exactly ${subscriptionDays} days. A shorter or longer duration is not allowed.`;
        }
      }

      if (subscriptionDateTimeError) {
        setShowAffectedBookings(false);
        setcostcalulator(null);
        setSelectedPaymentType("");
        setDateTimeError(subscriptionDateTimeError);
        return;
      }

      setDateTimeError("");
      getaffectedbookings();
      rescheduleCostCalculator();
      setSelectedPaymentType("");
    }
  }, [inputData, minBookingHrs, summaryDetails?.packageSelectedKey, subscriptionDays]);

  // useEffect(() => {

  // } ,[selectedPaymentType])

  const selectedDuration = useMemo(() => {
    const start = moment(
      `${inputData?.startDate || ""} ${inputData?.startTime || ""}`,
      "YYYY-MM-DD HH:mm",
      true,
    );
    const end = moment(
      `${inputData?.endDate || ""} ${inputData?.endTime || ""}`,
      "YYYY-MM-DD HH:mm",
      true,
    );

    if (!start.isValid() || !end.isValid() || !end.isAfter(start)) {
      return "";
    }

    const totalMinutes = end.diff(start, "minutes");
    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;

    return `${days} ${days === 1 ? "day" : "days"}, ${hours} ${
      hours === 1 ? "hour" : "hours"
    }, ${minutes} ${minutes === 1 ? "minute" : "minutes"}`;
  }, [
    inputData?.startDate,
    inputData?.startTime,
    inputData?.endDate,
    inputData?.endTime,
  ]);

  return (
    <div className="p-6">
      <div className="flex items-start justify-between gap-6 mb-8">
        <div>
          <h2 className="text-2xl font-semibold text-[#2c3e50]">
            Booking Reschedule Process
          </h2>

          <p className="mt-1 text-sm text-gray-500">
            Review the booking details before proceeding with the Reschedule.
          </p>
        </div>

        {SUBSCRIPTION_PACKAGE_DAYS[summaryDetails?.packageSelectedKey] && (
            <div className="flex items-start gap-3 max-w-md px-4 py-3 rounded-xl bg-orange-50 border border-orange-200 shadow-sm">
              <div className="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-lg bg-orange-100">
                <span className="text-orange-600 text-sm">📝</span>
              </div>

              <div>
                <p className="mt-1 text-xs leading-5 text-orange-700">
                  Note: This booking was created for {subscriptionDays ?? "an unknown number of"} days. Rescheduling must use exactly the same duration; a shorter or longer duration is not allowed.
                </p>
              </div>
            </div>
          )}
      </div>
      {/* <Bookingdetails1
        paymentDetailsData={paymentDetailsData}
        vehicleDetails={vehicleDetails}
        summaryDetails={summaryDetails}
        cities={cities}
      /> */}

      {/* <div className="section mt-10">      
        <div className="overflow-auto rounded-lg shadow bg-white">
          <table className="min-w-full text-sm text-left">
            <thead className="bg-gray-200 text-black">
              <tr>
                <th className="p-4">Weekday Rent</th>
                <th className="p-4">Weekend Rent</th>
                <th className="p-4">Discount Amount</th>
                <th className="p-4">Base Rent</th>
                <th className="p-4">Tax</th>
                <th className="p-4">Security Deposit</th>
                <th className="p-4">Pickup Charges</th>
                <th className="p-4">Delivery Charges</th>
                <th className="p-4 text-right">Rental</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b hover:bg-gray-50">
                <td className="p-4">
                  {summaryDetails?.weekdayRent +
                    "(" +
                    summaryDetails?.weekdayHrs +
                    " Hrs)" || "N/A"}
                </td>
                <td className="p-4">
                  {summaryDetails?.weekendRent +
                    "(" +
                    summaryDetails?.weekendHrs +
                    " Hrs)" || "N/A"}
                </td>
                <td className="p-4">
                  {summaryDetails?.discountAmount || "N/A"}
                </td>
                <td className="p-4">
                  {summaryDetails?.weekdayRent + summaryDetails?.weekendRent ||
                    "N/A"}
                </td>
                <td className="p-4">{summaryDetails?.taxAmount || "N/A"}</td>
                <td className="p-4">
                  {summaryDetails?.securityDeposit || "N/A"}
                </td>
                <td className="p-4">
                  {summaryDetails?.pickupCharges || "N/A"}
                </td>
                <td className="p-4">
                  {summaryDetails?.deliveryCharges || "N/A"}
                </td>
                <td className="p-4">
                  {summaryDetails?.weekdayRent +
                    summaryDetails?.weekendRent +
                    summaryDetails?.taxAmount +
                    summaryDetails?.securityDeposit +
                    summaryDetails?.pickupCharges +
                    summaryDetails?.deliveryCharges -
                    summaryDetails?.discountAmount || "N/A"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> */}

      <div className="mt-8">
        {/* <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2 border-b-4 pb-2 border-blue-500">
          Reschedule Booking Details
        </h2> */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {rescheduleDetailsInput.map((item, index) => (
            <div key={index} className="flex flex-col mx-auto">
              <label
                htmlFor={item?.value}
                className="text-gray-700 font-medium mb-1"
              >
                {item?.label}
              </label>

              {item.type === "time" ? (
                // Time Dropdown (30-min intervals)
                <select
                  id={item.value}
                  name={item.value}
                  value={inputData[item.value] || ""}
                  onChange={(e) => {
                    setPaymentTypeErrors("");
                    const { name, value } = e.target;
                    setInputData((prev) => ({
                      ...prev,
                      [name]: value,
                    }));
                    if (dateTimeError) setDateTimeError("");
                  }}
                  disabled={item?.isEnable}
                  className="border border-gray-300 rounded-md px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm transition h-11 w-full"
                >
                  <option value="">Select time</option>
                  {Array.from({ length: 48 }, (_, i) => {
                    const hours = Math.floor(i / 2);
                    const minutes = i % 2 === 0 ? "00" : "30";
                    const time = `${String(hours).padStart(2, "0")}:${minutes}`;
                    return (
                      <option
                        key={time}
                        value={time}
                        className="py-1 text-sm flex"
                      >
                        {time}
                      </option>
                    );
                  })}
                </select>
              ) : (
                // Normal Input for other types
                <input
                  id={item.value}
                  name={item.value}
                  type={item.type}
                  value={inputData[item.value] || ""}
                  onChange={(e) => {
                    const { name, value } = e.target;
                    setInputData((prev) => ({
                      ...prev,
                      [name]: value,
                    }));
                    if (dateTimeError) setDateTimeError("");
                  }}
                  disabled={item?.isEnable}
                  // min={
                  //   item.value === "endDate"
                  //     ? dynamicMinEndDate // SAME DAY ALLOWED
                  //     : item.value === "endTime"
                  //     ? getMinEndTime() // MIN END TIME ENFORCED
                  //     : item.min
                  // }
                  className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition w-full"
                />
              )}

              <p className="text-xs mt-2 text-gray-500">{item?.currentvalue}</p>
            </div>
          ))}
        </div>
        {/* <div className="mt-6 flex justify-end p-2">
          <button
            onClick={() => {
              const { startDate, startTime, endDate, endTime } = inputData;

              // reset previous error
              setDateTimeError("");

              if (!startDate || !startTime || !endDate || !endTime) {
                setDateTimeError(
                  "Please select Start Date, Start Time, End Date and End Time"
                );
                return;
              }

              const start = new Date(`${startDate}T${startTime}`);
              const end = new Date(`${endDate}T${endTime}`);

              if (end <= start) {
                setDateTimeError(
                  "End date & time must be after start date & time"
                );
                return;
              }

              setLoading(true);

              // ✅ all good
              getaffectedbookings();
              rescheduleCostCalculator();
              setPaymentTypeErrors("");
            }}
            // disabled={inputData.length > 3 ? false : true}
            type="submit"
            className="flex gap-2 items-end shadow-xl text-lg bg-gray-50 backdrop-blur-md lg:font-semibold isolation-auto border-gray-50 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-emerald-500 hover:text-gray-50 before:-z-10 before:aspect-square before:hover:scale-150 before:hover:duration-700 relative z-10 px-4 py-2 overflow-hidden border-2 rounded-full group"
          >
            Calculate Cost
          </button>
        </div> */}
        <div className="w-full flex flex-col md:flex-row md:items-center md:justify-end gap-3 mb-4 md:mb-0 px-6 mt-6">
          {selectedDuration && (
            <div className="inline-flex items-center gap-2 rounded-lg border border-orange-100 bg-orange-50 px-3 py-2 shadow-sm">
              <div className="flex h-7 w-7 items-center justify-center rounded-md bg-orange-100">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 text-orange-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 8v4l3 2m6-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>

              <div className="flex items-center gap-2 text-sm">
                <span className="font-medium text-gray-500">
                  Selected Duration
                </span>

                <span className="font-semibold text-gray-900">
                  {selectedDuration}
                </span>
              </div>
            </div>
          )}
        </div>

        {dateTimeError && (
          <p className="mt-2 text-sm text-red-600 text-right">
            {dateTimeError}
          </p>
        )}
      </div>

      {loading ? (
        <>
          <div className="flex justify-center items-center mt-6">
            <BlinkBlur size={40} color="#3b82f6" />
          </div>
        </>
      ) : (
        showAffectedBookings && (
          <>
            <div className="mt-12">
              <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
                Affected Bookings
              </h2>

              <div className="overflow-auto rounded-lg shadow bg-white">
                <table className="min-w-full text-sm text-left shadow-lg border border-gray-100">
                  <thead className="">
                    <tr>
                      <th className="p-4">ID</th>
                      <th className="p-4">Booking Code</th>
                      <th className="p-4">Book From</th>
                      <th className="p-4">Book To</th>
                      <th className="p-4">Status</th>
                      <th className="p-4 text-right">Ticket Size</th>
                    </tr>
                  </thead>
                  <tbody>
                    {affectedBookings.length ? (
                      affectedBookings.map((data) => (
                        <tr
                          key={data?.id}
                          className="border-b hover:bg-gray-50"
                        >
                          <td className="p-4">{data?.id}</td>
                          <td className="p-4">{data?.bookingCode}</td>
                          <td className="p-4">{data?.bookFrom}</td>
                          <td className="p-4">{data?.bookTo}</td>
                          <td className="p-4">
                            {fleetBookingStatus[data?.bookingStatus]}
                          </td>
                          <td className="p-4 text-right">
                            {data?.costToCustomer}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="6"
                          className="text-center p-4 text-gray-500"
                        >
                          No affected bookings found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {costcalulator && (
              <>
                <div className="p-6 mt-6 bg-gradient-to-br from-green-50 to-green-100 shadow-xl rounded-2xl">
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {[
                      {
                        name: "Resch Start Date",
                        value:
                          inputData?.startDate + "," + inputData?.startTime,
                      },
                      {
                        name: "Resch End Date",
                        value: inputData?.endDate + "," + inputData?.endTime,
                      },
                      {
                        name: "Vehicle Name",
                        value: summaryDetails?.vehicleName,
                      },
                      {
                        name: "Vehicle Registration",
                        value: summaryDetails?.vehicleRegistrationNo,
                      },
                      {
                        name: "Weekday Hrs",
                        value: costcalulator?.weekdayHrs + " hrs",
                      },
                      {
                        name: "Weekday Rent",
                        value: "₹ " + costcalulator?.weekdayRent + ".00",
                      },
                      {
                        name: "Weekend Hrs",
                        value: costcalulator?.weekendHrs + " hrs",
                      },
                      {
                        name: "Weekend Rent",
                        value: "₹ " + costcalulator?.weekendRent,
                      },
                      {
                        name: "Total Hrs",
                        value: costcalulator?.totalHrs + " hrs",
                      },
                      {
                        name: "Total Free Km",
                        value: costcalulator?.totalFreeKms + " Kms",
                      },
                      {
                        name: "Sub Total",
                        value: "₹ " + costcalulator?.baseFare + ".00",
                      },
                      // {
                      //   name: "Discount %",
                      //   value: summaryDetails?.discountPercentage || 0,
                      // },
                      // {
                      //   name: "Discount Amount",
                      //   value: "₹ " + summaryDetails?.discountAmount || 0,
                      // },
                      {
                        name: "Tax Amount",
                        value: "₹ " + costcalulator?.taxAmount + ".00",
                      },
                      {
                        name: "Delivery Charges",
                        value: "₹ " + summaryDetails?.deliveryCharges,
                      },
                      {
                        name: "Pickup Charges",
                        value: "₹ " + summaryDetails?.pickupCharges,
                      },
                      {
                        name: "Security Deposit",
                        value: "₹ " + summaryDetails?.securityDeposit + ".00",
                      },
                      {
                        name: "Total Rent",
                        value:
                          "₹ " +
                          pendingAmount?.rescheduleRentalDetails
                            ?.costToCustomer +
                          ".00",
                      },
                      {
                        name: "Previous Booking Rent",
                        value:
                          "₹ " + paymentDetailsData?.costToCustomer + ".00",
                      },
                      {
                        name: "Amount To Be Paid",
                        value: "₹ " + pendingAmount?.pendingAmount + ".00",
                      },
                    ].map(({ name, value }, index) => (
                      <div
                        key={index}
                        className="flex flex-col p-4 bg-white rounded-xl shadow hover:shadow-lg transition-all border border-green-100"
                      >
                        <h3 className="text-sm font-medium text-gray-500">
                          {name}
                        </h3>
                        <p
                          title={value}
                          className="text-lg font-semibold text-gray-800 mt-1 w-66 truncate"
                        >
                          {value || "-"}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mt-8">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* <label>Requested By</label>
              <select className="w-92 h-12 p-3 border border-gray-300 rounded-md">
                <option>Select</option>
                <option>Admin</option>
                <option>Customer</option>
              </select> */}
                    <label>Payment Collection Type</label>
                    <select
                      value={selectedPaymentType}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSelectedPaymentType(value);
                        if (value === "Pre Paid") {
                          // if (pendingAmount?.pendingAmount > 0) {
                          //   setPaymentTypeErrors(
                          //     "* Please clear the pending amount before selecting Pre Paid"
                          //   );
                          //   return;
                          // }
                          if (pendingAmount?.pendingAmount < 0) {
                            setPaymentTypeErrors(
                              "* Cannot able to Proceed having negative amount",
                            );
                            return;
                          }
                        }

                        setPaymentTypeErrors(""); // clear error if valid
                      }}
                      className="w-92 h-12 p-3 border border-gray-300 rounded-md"
                    >
                      <option>Select</option>
                      {Object.entries(paymentCollectionType).map(
                        ([key, val]) => (
                          <option key={key}>{val}</option>
                        ),
                      )}
                    </select>
                  </div>
                  {paymentTypeErrors && (
                    <p className="text-red-500 text-sm mt-1 text-end">
                      {paymentTypeErrors}
                    </p>
                  )}
                </div>

                {selectedPaymentType === "Pre Paid" &&
                !(pendingAmount?.pendingAmount < 0) ? (
                  <>
                    <div className="grid grid-cols-1 md:grid-cols-4 p-2 gap-4 my-4">
                      {transactionDetailsInput.map((input, index) => (
                        <div key={index}>
                          {input.type === "file" ? (
                            <>
                              <input
                                type="file"
                                accept="image/*" // or any file type
                                onChange={(e) =>
                                  handleInputChange(input.value, e)
                                }
                              />
                              {errors[input.value] && (
                                <p className="text-red-500 text-sm mt-1">
                                  {errors[input.value]}
                                </p>
                              )}
                            </>
                          ) : (
                            <TextField
                              fullWidth
                              type={input.type}
                              label={input.label}
                              disabled={input?.isEnable}
                              value={transactiondetails[input.value] || ""}
                              onChange={(e) =>
                                handleInputChange(input.value, e)
                              }
                              error={!!errors[input.value]}
                              helperText={errors[input.value]}
                              InputLabelProps={{ shrink: true }}
                            />
                          )}
                        </div>
                      ))}
                    </div>

                    <div className="flex justify-end gap-4">
                      <button
                        onClick={() => {
                          if (hasUnstableConnection) {
                            setPaymentLinkGenerated(false);
                            toast.error(
                              "Please check your network connection. Your internet connection appears to be unstable.",
                              {
                                position: "bottom-center",
                                style: {
                                  background: "white", // override background
                                  color: "red",
                                  fontWeight: "medium",
                                  marginBottom: "20px",
                                },
                              },
                            );
                          } else {
                            if (!paymentLinkGenerated) {
                              generatepaymentlink("generate");
                            }
                          }
                        }}
                        class={`${
                          paymentLinkGenerated
                            ? "cursor-not-allowed opacity-50"
                            : "cursor-pointer"
                        } text-white font-bold relative text-[14px] w-[14em] h-[3em] text-center bg-gradient-to-r from-violet-500 from-10% via-sky-500 via-30% to-pink-500 to-90% bg-[length:400%] rounded-[30px] z-10 hover:animate-gradient-xy hover:bg-[length:100%] before:content-[''] before:absolute before:-top-[5px] before:-bottom-[5px] before:-left-[5px] before:-right-[5px] before:bg-gradient-to-r before:from-violet-500 before:from-10% before:via-sky-500 before:via-30% before:to-pink-500 before:bg-[length:400%] before:-z-10 before:rounded-[35px] before:hover:blur-xl before:transition-all before:ease-in-out before:duration-[1s] before:hover:bg-[length:10%] active:bg-violet-700 focus:ring-violet-700 hover:brightness-110 hover:-translate-y-[1px] active:brightness-90 active:translate-y-[2px]`}
                      >
                        + Generate Payment Link
                      </button>

                      <button
                        onClick={handleSave}
                        disabled={
                          ![
                            "transactionid",
                            "transactioncharges",
                            "paymentmode",
                            "payableamount",
                            "paymentremarks",
                            "attachments",
                          ].every(
                            (key) =>
                              transactiondetails[key] !== null &&
                              transactiondetails[key] !== undefined &&
                              transactiondetails[key] !== "",
                          )
                        }
                        className={`relative inline-flex items-center gap-2 px-6 py-3 font-semibold text-teal-50 
      bg-gradient-to-tr from-teal-900/50 via-teal-900/90 to-teal-900/30 ring-4 ring-teal-900/20 
      rounded-full overflow-hidden hover:opacity-90 transition-opacity 
      before:absolute before:top-4 before:left-1/2 before:-translate-x-1/2 
      before:w-[100px] before:h-[100px] before:rounded-full before:bg-gradient-to-b 
      before:from-teal-50/10 before:blur-xl
      ${
        ![
          "transactionid",
          "transactioncharges",
          "paymentmode",
          "payableamount",
          "paymentremarks",
          "attachments",
        ].every(
          (key) =>
            transactiondetails[key] !== null &&
            transactiondetails[key] !== undefined &&
            transactiondetails[key] !== "",
        )
          ? "opacity-50 cursor-not-allowed"
          : ""
      }`}
                      >
                        + Add Payment
                      </button>
                    </div>

                    {generatePaymentlinks && (
                      <div className="mt-8">
                        {/* Slow Network Warning */}
                        {hasUnstableConnection && (
                          <div className="mb-3 flex items-center gap-2 rounded-lg border border-red-200 bg-red-50 px-4 py-3">
                            <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-600">
                              <InfoIcon />
                            </div>

                            <div>
                              <p className="text-sm font-semibold text-red-700">
                                Slow Network
                              </p>
                              <p className="text-xs text-red-600">
                                Your network connection is not stable. Please
                                check your internet connection before
                                proceeding.
                              </p>
                            </div>
                          </div>
                        )}

                        {/* Payment Links Table */}
                        <div
                          className={`overflow-x-auto rounded-lg border shadow-lg ${
                            hasUnstableConnection
                              ? "border-red-200 bg-red-50"
                              : "border-gray-100 bg-white"
                          }`}
                        >
                          <table className="min-w-full text-sm text-left">
                            <thead
                              className={
                                hasUnstableConnection
                                  ? "bg-red-100"
                                  : "bg-gray-50"
                              }
                            >
                              <tr>
                                <th className="whitespace-nowrap p-4 font-semibold">
                                  Payment Id
                                </th>

                                <th className="whitespace-nowrap p-4 font-semibold">
                                  Total Amount
                                </th>

                                <th className="whitespace-nowrap p-4 font-semibold">
                                  Payment Url
                                </th>

                                <th className="whitespace-nowrap p-4 font-semibold">
                                  Status
                                </th>

                                <th className="whitespace-nowrap p-4 font-semibold">
                                  Generated At
                                </th>

                                {generatePaymentlinks?.status === "captured" ? (
                                  <></>
                                ) : (
                                  <th className="whitespace-nowrap p-4 text-right font-semibold">
                                    Actions
                                  </th>
                                )}
                              </tr>
                            </thead>

                            <tbody>
                              {generatePaymentlinks ? (
                                <tr
                                  key={generatePaymentlinks?.id}
                                  className={`border-b ${
                                    hasUnstableConnection
                                      ? "border-red-200 hover:bg-red-100"
                                      : "border-gray-100 hover:bg-gray-50"
                                  }`}
                                >
                                  <td className="whitespace-nowrap p-4">
                                    {generatePaymentlinks?.paymentId}
                                  </td>

                                  <td className="whitespace-nowrap p-4">
                                    {"₹ " + generatePaymentlinks?.amount}
                                  </td>

                                  <td className="p-4">
                                    <span className="block max-w-[300px] truncate">
                                      {generatePaymentlinks?.shortUrl}
                                    </span>
                                  </td>

                                  <td className="whitespace-nowrap p-4">
                                    <span
                                      className={`inline-flex rounded-full px-3 py-1 text-xs font-medium ${
                                        generatePaymentlinks?.status ===
                                        "captured"
                                          ? "bg-green-100 text-green-700"
                                          : "bg-yellow-100 text-yellow-700"
                                      }`}
                                    >
                                      {generatePaymentlinks?.status}
                                    </span>
                                  </td>

                                  <td className="whitespace-nowrap p-4">
                                    {formatDateAndTime(
                                      generatePaymentlinks?.createdAt,
                                    )}
                                  </td>

                                  {generatePaymentlinks?.status ===
                                  "captured" ? (
                                    <></>
                                  ) : (
                                    <td className="p-4 text-right">
                                      <button
                                        type="button"
                                        disabled={paymentLinkGenerated}
                                        onClick={() => {
                                          if (hasUnstableConnection) {
                                            setPaymentLinkGenerated(false);

                                            toast.error(
                                              "Slow Network — Your network connection is not stable. Please check your internet connection.",
                                              {
                                                position: "bottom-center",
                                                style: {
                                                  background: "white",
                                                  color: "red",
                                                  fontWeight: "medium",
                                                  marginBottom: "20px",
                                                },
                                              },
                                            );
                                          } else {
                                            if (!paymentLinkGenerated) {
                                              generatepaymentlink("actions");
                                            }
                                          }
                                        }}
                                        className={`inline-flex items-center justify-center rounded-md px-3 py-2 transition ${
                                          paymentLinkGenerated
                                            ? "cursor-not-allowed bg-gray-100 text-gray-400"
                                            : hasUnstableConnection
                                              ? "cursor-pointer bg-red-100 text-red-600 hover:bg-red-200"
                                              : "cursor-pointer bg-gray-100 text-gray-700 hover:bg-gray-200"
                                        }`}
                                      >
                                        <InfoIcon />
                                      </button>
                                    </td>
                                  )}
                                </tr>
                              ) : (
                                <tr>
                                  <td
                                    colSpan="6"
                                    className="p-4 text-center text-gray-500"
                                  >
                                    No payment links found.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {paymentSavedDetails && (
                      <table className="min-w-full text-sm text-left shadow-lg border border-gray-100 mt-8">
                        <thead className="">
                          <tr>
                            <th className="p-4">Transaction Code</th>
                            <th className="p-4">Total Amount</th>
                            <th className="p-4">Payment Mode</th>
                            <th className="p-4">Description</th>
                            <th className="p-4">Generated At</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paymentSavedDetails ? (
                            <tr className="border-b hover:bg-gray-50">
                              <td className="p-4">
                                {paymentSavedDetails?.transactionCode}
                              </td>
                              <td className="p-4">
                                {"₹ " + paymentSavedDetails?.amount}
                              </td>
                              <td className="p-4">
                                {paymentSavedDetails?.paymentMode}
                              </td>
                              <td className="p-4">
                                {paymentSavedDetails?.description}
                              </td>
                              <td className="p-4">
                                {formatDateAndTime(
                                  paymentSavedDetails?.createdAt,
                                )}
                              </td>
                            </tr>
                          ) : (
                            <tr>
                              <td
                                colSpan="6"
                                className="text-center p-4 text-gray-500"
                              >
                                No payment links found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}

                    {(generatePaymentlinks?.status === "captured" ||
                      paymentSavedDetails) && (
                      <div className="flex justify-end">
                        <button
                          onClick={() => {
                            if (!selectedPaymentType) {
                              setPaymentTypeErrors(
                                "* Please select payment type",
                              );
                              return;
                            } else if (
                              selectedPaymentType !== "Freeze" &&
                              pendingAmount?.pendingAmount < 0
                            ) {
                              setPaymentTypeErrors(
                                "* Cannot able to Proceed having negative amount",
                              );
                              return;
                            }
                            updateBooking();
                          }}
                          // onClick={updateBooking}
                          className="cursor-pointer mt-8 bg-gradient-to-b from-indigo-500 to-indigo-600 shadow-[0px_4px_32px_0_rgba(99,102,241,.70)] px-6 py-3 rounded-xl border border-slate-500 text-white font-medium"
                        >
                          Update Booking
                        </button>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="flex justify-end">
                    <button
                      onClick={() => {
                        if (!selectedPaymentType) {
                          setPaymentTypeErrors("* Please select payment type");
                          return;
                        } else if (
                          selectedPaymentType !== "Freeze" &&
                          pendingAmount?.pendingAmount < 0
                        ) {
                          setPaymentTypeErrors(
                            "* Cannot able to Proceed having negative amount",
                          );
                          return;
                        }
                        updateBooking();
                      }}
                      // onClick={updateBooking}
                      className="cursor-pointer mt-8 bg-gradient-to-b from-indigo-500 to-indigo-600 shadow-[0px_4px_32px_0_rgba(99,102,241,.70)] px-6 py-3 rounded-xl border border-slate-500 text-white font-medium"
                    >
                      Update Booking
                    </button>
                  </div>
                )}
              </>
            )}
          </>
        )
      )}
    </div>
  );
};

export default Reschedule;
